/*
 * Copyright (c) 2025, Wultra s.r.o. (www.wultra.com).
 *
 * All rights reserved. This source code can be used only for purposes specified
 * by the given license contract signed by the rightful deputy of Wultra s.r.o.
 * This source code can be used only by the owner of the license.
 *
 * Any disputes arising in respect of this agreement (license) shall be brought
 * before the Municipal Court of Prague.
 */

import { makeAutoObservable } from "mobx"

import type { EventBus } from "../../event-bus/event-bus"
import { EventBusEvent } from "../../event-bus/event-bus"
import type { UserRole } from "../user/user-types"
import { toUserRoles } from "../user/user-types"

export class AppState {
    isRouteLoading = false
    roles: UserRole[] = []

    constructor(eventBus: EventBus) {
        makeAutoObservable(this, {
            setRouteLoading: true,
            setUserRoles: true
        })
        // roles are used to show / hide parts of the app in UI
        eventBus.on(EventBusEvent.CurrentUserLoaded, (user) => {
            this.setUserRoles(toUserRoles(user.roles ?? []))
        })
    }

    setRouteLoading(isLoading: boolean): void {
        this.isRouteLoading = isLoading
    }

    setUserRoles(roles: UserRole[]): void {
        this.roles = roles
    }
}
